export default __webpack_public_path__ + "static/media/ppns-image-5.e4c3b667.png";